import { handleActions, Action } from 'redux-actions';

import * as ACTIONS from '../constants/actions';

const initialState = {
    data: false
  };
  
  const dataReducer = (state = initialState, action: Action<any> ) => {
    switch (action.type) {
      case ACTIONS.SET_DATA_CHANGED:
        return {
          ...state,
          data: action.payload,
        };
      default:
        return state;
    }
  };

  const dataReducers = handleActions<any, any>(
    {
      [ACTIONS.SET_DATA_CHANGED]: dataReducer,         
    },
    initialState
  );
  

  export default dataReducers;